import { render, staticRenderFns } from "./BazarForm.vue?vue&type=template&id=6a0ebed1&"
import script from "./BazarForm.vue?vue&type=script&lang=js&"
export * from "./BazarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports